import { useState } from "react";
import { authClient } from "@/lib/auth";
import { SignInForm } from "@/features/auth/sign-in";
import { AppLayout } from "@/app/layout/app-layout";
import { DashboardPage } from "@/app/pages/dashboard-page";
import { CelebritiesPage } from "@/app/pages/celebrities-page";
import type { AdminPage } from "@/app/layout/sidebar";

export function App() {
  const { data: session, isPending } = authClient.useSession();
  const [page, setPage] = useState<AdminPage>("dashboard");

  const handleSignOut = () => {
    void authClient.signOut();
  };

  if (isPending) {
    return (
      <div className="flex min-h-dvh items-center justify-center">
        <p className="text-sm text-foreground/60">Checking session…</p>
      </div>
    );
  }

  if (!session) {
    return <SignInForm />;
  }

  return (
    <AppLayout
      page={page}
      onNavigate={setPage}
      email={session.user.email ?? ""}
      onSignOut={handleSignOut}
    >
      {page === "dashboard" ? <DashboardPage /> : <CelebritiesPage />}
    </AppLayout>
  );
}
